import {Component, Inject, OnInit} from '@angular/core';
import {DataARClaimItemListModel} from '../../models/data-ar-claim-item-list';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {ValidationLogItem} from '../../models/ValidationLogItem.model';

@Component({
  selector: 'app-claim-validation-detail',
  templateUrl: './claim-validation-detail.component.html',
  styleUrls: ['./claim-validation-detail.component.css']
})
export class ClaimValidationDetailComponent implements OnInit {

  validationLogItems: ValidationLogItem[] = [];
  searchPredicate: (data: any, filter: string) => boolean;
  isLoading: boolean = false;
  itemsComplete: number = 0;
  itemsInComplete: number = 0;
  internalValidation: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ClaimValidationDetailComponent>,
    public globals: Globals,
  ) {
    this.searchPredicate = (searchData: DataARClaimItemListModel, filter: string) => {
      if ((!searchData.ToothName ? '' : searchData.ToothName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.ProcedureName ? '' : searchData.ProcedureName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit(): void {
    this.validationLogItems = this.data.ValidationLogItems;
    this.internalValidation = true;
    if (this.getDXCResponse()) {
      this.internalValidation = false;
    }

    if (this.validationLogItems) {
      this.validationLogItems.forEach(a => {
        if (a.ValidationItemType === 1 && a.ValidationPass) {
          this.itemsComplete++;
        }
        else if (a.ValidationItemType === 1 && !a.ValidationPass) {
          this.itemsInComplete++;
        }
      });
    }
  }

  closeRef() {
    this.dialogRef.close();
  }

  getDXCResponse() {
    let resp = '';
    this.validationLogItems.forEach(a => {
      if (a.ValidationHint && a.ValidationHint === 'showintextarea') {
        resp = a.ValidationItemName;
      }
    });
    return resp;
  }
}
